import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

/**
 * Import products from Excel file
 * @param {FormData} formData - FormData containing file and options
 * @param {File} formData.file - Excel file (.xlsx or .xls)
 * @param {String} formData.locale - Optional locale for translations (default: "en")
 * @param {Boolean} formData.update_existing - Optional: Update existing products (default: true)
 */
export const importProductsFunc = createAsyncThunk(
  "importProductsSlicer/importProductsFunc",
  async (formData, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await api.post(
        'dashboard/products/import',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const importProductsSlicer = createSlice({
  name: "importProductsSlicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
    success: false,
    imported: 0,
    updated: 0,
    skipped: 0,
    errors: [],
  },
  reducers: {
    resetImportState: (state) => {
      state.error = null;
      state.success = false;
      state.data = null;
      state.imported = 0;
      state.updated = 0;
      state.skipped = 0;
      state.errors = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(importProductsFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.imported = 0;
        state.updated = 0;
        state.skipped = 0;
        state.errors = [];
      })
      .addCase(importProductsFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        
        // Extract import statistics
        if (action.payload?.data) {
          state.imported = action.payload.data.imported || 0;
          state.updated = action.payload.data.updated || 0;
          state.skipped = action.payload.data.skipped || 0;
          state.errors = action.payload.data.errors || [];
        }
      })
      .addCase(importProductsFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        
        // Extract errors from response
        if (action.payload?.errors) {
          state.errors = Array.isArray(action.payload.errors)
            ? action.payload.errors
            : [action.payload.errors];
        } else if (action.payload?.message) {
          state.errors = [action.payload.message];
        }
      });
  },
});

export const { resetImportState } = importProductsSlicer.actions;
export default importProductsSlicer.reducer;
